/**
 * Kinds of automatic email a user can opt out of, from Manage Users.
 *
 * A user's opt-outs are stored on their {org}-Users record as `emailOptOuts`
 * (an array of these keys). Missing or empty = receives everything. The backend
 * enforces them at send time; the web only edits the list.
 *
 * Scheduled reports are deliberately NOT here: a user subscribes to a report on
 * purpose, so it is not an automatic notification and is never suppressible.
 *
 * Keys must match the backend's category keys exactly (agreed with the backend
 * 2026-10-21 after its email inventory; docs/permissions-backend-queue.md item 10).
 * No `workflow` key: workflow-requests sends no email.
 *
 * `featureFlag`: only offered in orgs whose environment sets that flag true.
 * `stopsActionEmails`: opting out also stops "it's your turn to review/approve"
 * emails, so Manage Users makes the admin type "agree" first (David, 2026-10-21).
 */
export interface EmailCategory {
  key: string;
  label: string;
  description: string;
  featureFlag?: 'timesheets' | 'timecards';
  stopsActionEmails?: boolean;
}

export const EMAIL_CATEGORIES: readonly EmailCategory[] = [
  { key: 'contract-notices', label: 'Contract notices', description: 'Auto-renewed, expired, notice deadlines' },
  { key: 'important-dates', label: 'Important Dates', description: 'Reminders, assignments and calendar invites' },
  { key: 'timesheets', label: 'Timesheets', description: 'Receipts, status updates and "needs your action"',
    featureFlag: 'timesheets', stopsActionEmails: true },
  { key: 'timecards', label: 'Timecards', description: 'Receipts, status updates and "needs your action"',
    featureFlag: 'timecards', stopsActionEmails: true },
];
